<template>
  <span class="radio-group">
    <label
      class="radio-group__option"
      v-for="option in options"
      :key="option.value"
    >
      <input
        type="radio"
        :name="name"
        :value="option.value"
        :checked="value === option.value"
        @change="$emit('input', option.value)"
      >
      {{ option.label }}
    </label>
  </span>
</template>

<script>
  export default {
    props: {
      value: {
        type: String,
        required: true
      },
      options: {
        type: Array,
        required: true
      },
      name: {
        type: String,
        required: true
      }
    }
  }
</script>

<style scoped>
  .radio-group {
    display: inline-flex;
    gap: 12px;
    align-items: center;
  }

  .radio-group__option {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-weight: normal;
    margin-bottom: 0;
    cursor: pointer;
  }

  .radio-group__option input {
    margin: 0;
  }
</style>
